import React from "react";
import FacebookIcon from "../assets/icons/social/facebook.svg";
import InstagramIcon from "../assets/icons/social/instagram.svg";
import TikTokIcon from "../assets/icons/social/tiktok.svg";
import YouTubeIcon from "../assets/icons/social/youtube.svg";
import SpotifyIcon from "../assets/icons/social/spotify.svg";
import TwitterIcon from "../assets/icons/social/twitter.svg";
import useDevice from "../hooks/useDevice";
import DiscoverSkeleton from "./Skeletons/DiscoverSkeleton";

const Discover = ({ data, loading }) => {
  const { isDesktop, isTablet } = useDevice();

  if (loading) return <DiscoverSkeleton />;

  return (
    <>
      <div
        id="r_discoverSection"
        style={{
          display: "flex",
          flexDirection: "column",
          margin: isDesktop ? "0" : "0 16px",
          gap: 24,
          flexGrow: 1,
        }}
      >
        <span
          style={{
            color: "#0D0C1C",
            fontSize: 20,
            fontFamily: "pf_highway_sans_pro_mediumRg",
          }}
        >
          {artistpage_resources.Discover}
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <iframe
            width="100%"
            height={isTablet ? "152" : "352"}
            style={{ borderRadius: 8, borderWidth: 0 }}
            src={`https://open.spotify.com/embed/artist/${data.spotifyId}?theme=0`}
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "24px",
              gap: 16,
              borderRadius: 8,
              border: "1px solid #EDF1F6",
              backgroundImage: "url('/site/images/artist/discover.jpeg')",
              backgroundSize: "100% 100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", gap: 16 }}>
                {data.facebookUrl && (
                  <a href={data.facebookUrl} target="_blank">
                    <FacebookIcon />
                  </a>
                )}
                {data.instagramUrl && (
                  <a href={data.instagramUrl} target="_blank">
                    <InstagramIcon />
                  </a>
                )}
                {data.tikTokUrl && (
                  <a href={data.tikTokUrl} target="_blank">
                    <TikTokIcon />
                  </a>
                )}
                {data.youTubeUrl && (
                  <a href={data.youTubeUrl} target="_blank">
                    <YouTubeIcon />
                  </a>
                )}
                <a
                  href={`https://open.spotify.com/artist/${data.spotifyId}`}
                  target="_blank"
                >
                  <SpotifyIcon />
                </a>
                {data.twitterUrl && (
                  <a href={data.twitterUrl} target="_blank">
                    <TwitterIcon />
                  </a>
                )}
              </div>
              {data.websiteUrl && (
                <a
                  href={data.websiteUrl}
                  style={{
                    color: "#0D0C1C",
                    fontSize: 14,
                    lineHeight: "24px",
                    textDecoration: "none",
                  }}
                >
                  {data.websiteUrl
                    ?.replace("http://", "")
                    .replace("https://", "")}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Discover;
